<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">الاسئلة الشائعة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">الاسئلة الشائعة</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="checkAccess('questions_create')" class="row">
          <div class="col text-end">
            <router-link to="/questions/create" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة سؤال
            </router-link>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">الاسئلة الشائعة</div>
                <span v-if="countRows > 0"
                  class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto"> 
                  عدد النتائج ( {{ countRows }} )</span>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>السؤال</th>
                            <th>الترتيب</th>
                            <th>الحالة</th>
                            <th>اخر تحديث</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, indx) in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ row.question }}</td>
                            <td>{{ row.sortNum }}</td>
                            <td>{{ (row.isActive)? 'نشط' : 'غير نشط' }}</td>
                            <td>{{ $shortDate(row.updatedAt) }}</td>
                            <td>
                              <router-link :to="`/questions/update/${row.id}`" class="btn btn-light btn-sm me-3">
                                <i v-if="checkAccess('questions_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                              <button v-if="checkAccess('questions_delete')" class="btn btn-danger btn-sm" @click="deleteRow(row.id, indx)"><i class="bi bi-trash"></i></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess } from '@/helpers/tools';

export default {
  name: 'QuestionsList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: 1,
      pages: [],
      countRows: 0,
    }
  },
  methods: {
    checkAccess, 
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      this.$http.get(`/api/admin/questions/list?page=${this.currentPage}`).then(({data}) => {
        this.rows = data.rows;
        this.pages = data.pages ?? [this.currentPage];
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async deleteRow(id, index){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });
      
      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/questions/delete/${id}`).then(({data}) => {
          let buffer = this.rows;
          buffer.splice(index, 1);
          this.rows = buffer;
          // this.rows.splice(index, 1);
          toast('تم الحذف بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على الحذف');
        });
      }
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
  },
  created(){
    this.getList();
  }
}
</script>
